/**
 * @generated SignedSource<<e7df555f19b0d74a1a8c2d37640cbc3d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TermsAndConditionsConsent_consentSettings$data = {
  readonly consentedVersion: string | null;
  readonly currentVersion: string;
  readonly " $fragmentType": "TermsAndConditionsConsent_consentSettings";
};
export type TermsAndConditionsConsent_consentSettings$key = {
  readonly " $data"?: TermsAndConditionsConsent_consentSettings$data;
  readonly " $fragmentSpreads": FragmentRefs<"TermsAndConditionsConsent_consentSettings">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TermsAndConditionsConsent_consentSettings",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentVersion",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "consentedVersion",
      "storageKey": null
    }
  ],
  "type": "ConsentSettingsConnection",
  "abstractKey": null
};

(node as any).hash = "dabff07acc5aa42689284ecb35e2118b";

export default node;
